export const AppConfig = {
  googleApiKey: "AIzaSyDDAfrPKcVxx096l5SHZvoaWt7d-wrag-8",
  abacusCoreApiBaseUrl:
    process.env.NODE_ENV === "production"
      ? "https://us-central1-abacuscorev2live.cloudfunctions.net/"
      : "https://us-central1-abacus-company-project.cloudfunctions.net/",
  ForceUseSandboxPayment:
    process.env.NODE_ENV === "production" ? "false" : true,
  isBranded: "true",
  firebaseApiKey: "AIzaSyAtHqepcIJdj3pTaC0eyeK09wexEIxW5K4",
  firebaseProjectId: "abacusoo-sushi-hub",
  firebaseMessagingSenderId: "263704218289",
  stripeToken:
    process.env.NODE_ENV === "production"
      ? "pk_live_t7Kl1zBCn1HDreBi6MABv2hi"
      : "pk_test_Gkme8Wh8YEFLCeX9OP3duTTe",
  stripeTestToken: "pk_test_Gkme8Wh8YEFLCeX9OP3duTTe",
};
